<template>
  <div style="dispaly: flex;">
    <button
      type="button"
      title="Edit User"
      class="btn btn-primary userButtons"
      v-on:click="callParentEditFunction()"
      :disabled="isDisabled"
    >
      <i class="icon-profile"></i>
    </button>
    <button
      type="button"
      title="Reset Password"
      class="btn btn-primary ml-2 userButtons"
      v-on:click="callParentResetFunction()"
      :disabled="isDisabled"
    >
      <i class="icon-key"></i>
    </button>
    <button
      type="button"
      title="Delete User"
      class="btn btn-primary ml-2 userButtons"
      v-on:click="callParentDeleteFunction()"
      :disabled="
        params.data.edit.uid === this.$store.state.currentUser.uid || isDisabled
      "
    >
      <i class="icon-bin2"></i>
    </button>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'tableButtons',
  methods: {
    callParentEditFunction: function() {
      this.params.context.componentParent.editUser(
        this.params.data.edit,
        this.params.data
      );
    },
    callParentResetFunction: function() {
      this.params.context.componentParent.resetPassword(this.params.data.edit);
    },
    callParentDeleteFunction: function() {
      this.params.context.componentParent.deleteUser(this.params.data.edit);
    }
  },
  computed: {
    isDisabled() {
      return this.params.data.status === 'Deactivated';
    }
  }
});
</script>

<style scoped>
.userButtons:disabled:hover {
  color: #ad466c;
  background-color: inherit;
}
</style>
